import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';
import { STANDARD_SIZE } from './layout';

/**
 * Calculator.
 *
 * Fixed size, because calc.exe had no resize handle — each view was exactly
 * as big as its own buttons, and switching between them resized the window.
 * `layout.ts` holds the arithmetic that produces both sizes, converted from
 * the dialog units in the original's resources.
 *
 * Not a singleton: two calculators side by side is a reasonable thing to want,
 * and Windows never stopped anyone.
 *
 * Takes no args.
 */
export const calcApp: AppManifest = {
  id: 'calc',
  name: 'Calculator',
  icon: '/assets/icons/calc.svg',
  component: lazy(() => import('./Calculator')),

  defaultSize: STANDARD_SIZE,
  resizable: false,
  maximizable: false,
  singleton: false,

  group: 'Accessories',
  titleFor: () => 'Calculator',
};
